<template>
  <div>
    <v-text-field
        v-if="!inEditMode"
        class="flex-row-reverse"
        v-model=" value[text]"
        :label="label"
        solo
        :readonly="!!value.id"
    >
      <template v-slot:append-outer>
        <div class="d-inline-flex" v-if="value.id">

          <v-btn :class="{'btn-dec-with-text' : true , 'hidden-button' : hideRemove}"
                 @click="$emit('remove-submit' , value, index)"
                 style="margin-top: -0.5rem">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
          <v-btn class="btn-edit" style="margin-top: -0.5rem" @click="editText = value[text] ; inEditMode=true">
            <v-icon >fa-pencil-alt</v-icon>
          </v-btn>

        </div>

        <div class="d-inline-flex" v-else>
          <v-btn class="btn-cancel"
                 style="margin-top: -0.5rem"
                 @click="createCancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-btn class="btn-accept"
                 :disabled="!isValidForSubmit"
                 style="margin-top: -0.5rem"
                 @click="$emit('create-submit' , value , index , value[text])"
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
        </div>

      </template>

    </v-text-field>

    <v-text-field
        v-else
        class="flex-row-reverse"
        v-model="editText"
        :label="label"
        solo
    >
      <template v-slot:append-outer>
        <div class="d-inline-flex" >

          <v-btn class="btn-cancel"
                 style="margin-top: -0.5rem"
                 @click="inEditMode = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-btn class="btn-accept"
                 :disabled="!isValidForUpdate"
                 style="margin-top: -0.5rem"
                 @click="value[text] = editText ; $emit('update-submit' , value , index , value[text]) ; inEditMode=false"
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>

        </div>


      </template>

    </v-text-field>
  </div>
</template>

<script>
export default {
  name: "Component",
  props :{
    value : {
      type: Object
    },
    label:{
      type:String,
      default : "field"
    },
    text : {
      type:String,
      default : "name"
    },
    hideRemove : {
      type: Boolean,
      default : true
    },
    index : Number,
    onRemove : Function,
    wrongName : {
      type: Array,
      default : ()=>[]
    }
  },
  data(){
    return {
      inEditMode : false,
      editText : this.value[this.text]
    }
  },
  computed:{
    isValidForSubmit(){
      let text = (this.value[this.text] ?? "") .trim()
      if (this.wrongName.indexOf(text) !== -1) return false;
      return text.length >= 2;
    },

    isValidForUpdate(){
      let text = this.editText.trim()
      if (this.wrongName.indexOf(text) !== -1) return false;
      return text.length >= 2 && text !== this.value[this.text];
    }
  },
  methods:{
    createCancel(){
      this.$emit('on-create-cancel' , this.value , this.index)
    }
  }
}
</script>

<style scoped>
.hidden-button{
  visibility: hidden;
}
</style>